import { render } from "./Girls.vue?vue&type=template&id=3b3953ba"
import script from "./Girls.vue?vue&type=script&lang=js"
export * from "./Girls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__